import { apiRequest, initializeCsrf } from "@/lib/api";

export type DemoRequestPayload = {
  full_name: string;
  organization: string;
  email: string;
  phone: string;
  message: string;
  locale: "en" | "fr";
};

export async function submitDemoRequest(payload: DemoRequestPayload) {
  await initializeCsrf();

  return apiRequest<{ message: string }>("/demo-requests", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
